import React, { useEffect, useState } from 'react'
import { Button, Card, FormControlLabel, FormGroup, Grid, Switch, TextField, Typography, CircularProgress, Box, Collapse, IconButton } from '@mui/material'
import DataProductPage from '../DataProductPage/App'
import ExternalReportPage from '../ExternalReportsPage/ExternalReportPage'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import doRequest from '../../lib/services/apiRequestor'
import { DataObject, ExpandMore, ExpandLess } from '@mui/icons-material'
import QueryParameterFilters from '../../lib/components/QueryParameterFilters'
import { fetchCustomParameters, formatCustomParametersIntoFormData, clearCustomParameterVlaues, fetchAvailableDates } from '../../lib/services/customQueryService'
import DataPreviewCountSelector from '../../lib/components/DataPreviewCountSelector'
import { useParams, useLocation, useNavigate } from "react-router-dom"
import RequestStatusAlert from '../../lib/components/RequestStatusAlert';
import Banner from '../../lib/components/Banner';
import { fetchExternalReportDetails } from '../../lib/services/externalReportService';


const DataProductResult = ({user, idToken, drawerWidth, dataProduct }) => {
    const { dataProductName } = useParams();
    const location = useLocation();
    const data = location.state;
    const [value, setValue] = useState(dataProductName); //selected data product by user
    const navigate = useNavigate()
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [availableDates, setAvailableDates] = useState([]);
    const [getLatest, setGetLatest] = useState(true);
    const [submit, setSubmit] = useState(true);
    const [resubmit, setReSubmit] = useState(1);
    const [dataPreviewRowCount, setDataPreviewRowCount] = useState(1000);
    const [customParameters, setCustomParameters] = useState(null);
    const [toggleCustomParameters, setToggleCustomParameters] = useState(false);
    const [toggleClearFilters, setToggleClearFilters] = useState(false);
    const [customParameterValues, setCustomParameterValues] = useState({});
    const [statusMessage, setStatusMessage] = useState(null);
    const [severity, setSeverity] = useState(null);
    const [formData, setFormData] = useState({});
    const dateFormat = 'sv'; //ensures dates are formatted as 'YYYY-MM-DD'.
    const [message, setMessage] = useState(null);
    const [className, setClassName] = useState(null);
    const [showBanner, setShowBanner] = useState(false);
    const [dataProductDetails, setDataProductDetails] = useState(null);
    const [reportDetails, setReportDetails] = useState(null);
    const [loadingReport, setLoadingReport] = useState(true);
    const [reportExpanded, setReportExpanded] = useState(true);
    const [dataPreviewExpanded, setDataPreviewExpanded] = useState(true);
    const [relatedContentExpanded, setRelatedContentExpanded] = useState(true);

    useEffect(() => {
        if (toggleCustomParameters === true) {
            formatCustomParametersIntoFormData(customParameterValues, customParameters, setFormData)
        } else {
            setFormData({});
        }
    }, [customParameterValues, toggleCustomParameters])

    useEffect(() => {
        if (value == null) return
        else {
            // Fetch data product details first to get isDataPreviewEnabled
            doRequest(`/api/DataProduct?DataProductName=${value}`, idToken)
                .then((response) => {
                    if (!response.isError) {
                        setDataProductDetails(response.data);
                        // Only fetch custom parameters and available dates if data preview is enabled
                        if (response.data?.isDataPreviewEnabled === true) {
                            fetchAvailableDates(idToken, value, setAvailableDates);
                            fetchCustomParameters(idToken, value, setCustomParameters);
                        }
                        // If reportId exists, fetch report details
                        if (response.data?.reportId) {
                            fetchExternalReportDetails(idToken, response.data.reportId, setReportDetails, setLoadingReport, () => {});
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error fetching data product details:', error);
                });
        }
    }, [value])

    const handleGetLatest = (event) => {
        setGetLatest(event.target.checked);
    }

    const handleCustomParametersToggle = (event) => {
        setToggleCustomParameters(event.target.checked);
    }

    const disableDates = (date) => {
        return !availableDates.includes(date.toLocaleDateString(dateFormat))
    }

    const toggleDatePicker = (value) => {
        if (value == null | availableDates.length == 0 | getLatest == true) return true
        else if (value != null && availableDates.length > 0 && getLatest == false) return false
    }
    const handleBackClick = (event) => {
        navigate('/explore', { state: { searchValue: data ? data.search : '' } });
    }
    const handleClearFilterClick = (event) => {
        setToggleClearFilters(!toggleClearFilters);
        clearCustomParameterVlaues(customParameterValues, setCustomParameterValues, customParameters);
    }
    const updateStausMessage = (message, severity) => {
        if (message != null && severity != null) {
            setStatusMessage(message);
            setSeverity(severity);
        }
    }

    return (
        <Grid container spacing={2} style={{ width: 'auto', marginTop: "2px", marginLeft: drawerWidth - 15}} >
            <Grid item xs={12} style={{marginBottom: "2px"}}>
                <Button onClick={handleBackClick}><u>Back to Data Product List</u></Button>
            </Grid>
            <Grid container xs={12} >
                {/* Data Product info Grid - always displayed */}
                <Grid item xs={12} style={{marginBottom: "8px"}}>
                    <Typography variant={'h7'} component="span">Data Product Name: </Typography>
                    <Typography variant={'h6'} component="span" sx={{ wordBreak: "break-word" }}>{data ? data.productFriendlyName : value}</Typography>
                    {dataProductDetails?.description && (
                        <>
                            <br />
                            <Typography variant={'h7'}>Description: </Typography>
                            <Typography variant={'body1'} component="span">{dataProductDetails.description}</Typography>
                        </>
                    )}
                </Grid>
                
                {/* Data Preview Menu Grid - only display if preview is enabled - shown on the left hand side of the screen */}
                {dataProductDetails?.isDataPreviewEnabled === true && (
                <Grid item xs={4} style={{ height: '91.5vh', borderRight: '1px solid #eee', width: '100%', overflow: 'auto' }}>
                    <Grid container direction="row" rowSpacing={2} columnSpacing={2}>
                        <Grid item xs={12}>
                            <Button 
                                variant="contained" 
                                onClick={() => { setSubmit(true); setReSubmit(resubmit + 1) }}
                                disabled={dataProductDetails?.isDataPreviewEnabled !== true}
                            >
                                Run
                            </Button>
                        </Grid>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid item xs={11} xl={4}>
                                <DatePicker
                                    disabled={toggleDatePicker(value)}
                                    label="From"
                                    value={fromDate}
                                    onChange={setFromDate}
                                    renderInput={(params) => <TextField {...params} />}
                                    shouldDisableDate={disableDates}
                                    inputFormat="dd/MM/yyyy"
                                    mask="__/__/____"
                                />
                            </Grid>
                            <Grid item xs={11} xl={4}>
                                <DatePicker
                                    disabled={toggleDatePicker(value)}
                                    label="To"
                                    value={toDate}
                                    onChange={setToDate}
                                    renderInput={(params) => <TextField {...params} />}
                                    shouldDisableDate={disableDates}
                                    inputFormat="dd/MM/yyyy"
                                    mask="__/__/____"
                                />
                            </Grid>
                        </LocalizationProvider>
                        <Grid container item lg={12} xl={4} alignItems="center" >
                            <FormGroup>
                                <FormControlLabel control={<Switch defaultChecked onChange={handleGetLatest} />} label="Get Latest" />
                            </FormGroup>
                        </Grid>
                        <Grid item xl={4} md={6} xs={8}>
                            <DataPreviewCountSelector dataPreviewRowCount={dataPreviewRowCount} setDataPreviewRowCount={setDataPreviewRowCount} />
                        </Grid>
                        <Grid item xs={12}>
                            {customParameters && customParameters.length > 0 && value &&
                                <QueryParameterFilters
                                user={user}
                                dataProductName={value}
                                customParameters={customParameters}
                                handleCustomParametersToggle={handleCustomParametersToggle}
                                setCustomParameterValues={setCustomParameterValues}
                                idToken={idToken}
                                toggleCustomParameters={toggleCustomParameters}
                                customParameterValues={customParameterValues}
                                handleClearFilterClick={handleClearFilterClick}
                                toggleClearFilters={toggleClearFilters}
                                openedFrom={"dataProduct"}
                                updateStausMessage={updateStausMessage}
                                formData={formData}
                                setFormData={setFormData}
                                />
                            }
                        </Grid>
                    </Grid>
                </Grid>
                )}
                <Grid item xs={(dataProductDetails?.isDataPreviewEnabled === true) ? 8 : 12} >
                    {/* relatedContent collapsible Grid - only display if configured */}
                    {dataProductDetails?.relatedContent && dataProductDetails.relatedContent.length > 0 && (
                    <Grid item xs={12} sx={{ border: '1px solid #e0e0e0', borderRadius: '4px'}}>
                            <Card 
                                variant="outlined" 
                                sx={{ 
                                    padding: '10px 20px', 
                                    backgroundColor: 'primary.light',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    border: 'none'
                                }}
                                onClick={() => setRelatedContentExpanded(!relatedContentExpanded)}
                            >
                                <Typography variant="h7">
                                    Related Content
                                </Typography>
                                <IconButton size="small">
                    {relatedContentExpanded ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Card>
                            <Collapse in={relatedContentExpanded} timeout="auto" unmountOnExit>
                                <Box sx={{ mt: 1, p: 2 }}>
                                    {dataProductDetails.relatedContent.map((content, index) => (
                                        <Box key={index} sx={{ mb: 1.5 }}>
                                            {content.description && (
                                                <Typography variant="body2" sx={{ mb: 0.5, color: 'text.secondary' }}>
                                                    {content.description}
                                                </Typography>
                                            )}
                                            <Typography variant="body2">
                                                <a href={content.contentLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: '#055a60' }}>
                                                    {content.displayTitle}
                                                </a>
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Collapse>
                    </Grid>
                    )}
                    {/* related reports Grid - only display if configured - shown in iframe */}
                    {dataProductDetails?.reportId && (
                        loadingReport ? (
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <CircularProgress />
                            </Box>
                        ) : reportDetails ? (
                            <Grid container xs={12} sx={{ border: '1px solid #e0e0e0', borderRadius: '4px' }}>                                                
                                    <Card 
                                        variant="outlined" 
                                        sx={{ 
                                            padding: '10px 20px', 
                                            backgroundColor: 'primary.light',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            border: 'none'
                                        }}
                                        onClick={() => setReportExpanded(!reportExpanded)}
                                    >
                                        <Typography variant="h7">
                                            {reportDetails.title}
                                        </Typography>
                                        <IconButton size="small">
                                            {reportExpanded ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                    </Card>
                                <Collapse in={reportExpanded} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
                                    <Grid container xs={12}>
                                        <ExternalReportPage report={reportDetails} loading={false} currentDataProductId={dataProductDetails.dataProductName} />
                                    </Grid>
                                </Collapse>
                            </Grid>
                        ) : null
                    )}
                    {/* Data Preview Content result Grid - only display if preview is enabled - shown on the right hand side of the screen */}
                    {value && submit && dataProductDetails?.isDataPreviewEnabled === true && (
                    <Grid container xs={12} sx={{ border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                            <Grid item xs={12}>
                                <Card 
                                    variant="outlined" 
                                    sx={{ 
                                        padding: '10px 20px', 
                                        backgroundColor: 'primary.light',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        marginBottom: '10px',
                                        border: 'none'
                                    }}
                                    onClick={() => setDataPreviewExpanded(!dataPreviewExpanded)}
                                >
                                    <Typography variant="h6">
                                        Data Preview
                                    </Typography>
                                    <IconButton size="small">
                                        {dataPreviewExpanded ? <ExpandLess /> : <ExpandMore />}
                                    </IconButton>
                                </Card>
                            </Grid>
                            <Collapse in={dataPreviewExpanded} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
                                <Grid container xs={12}>
                                    <Grid item xs={12}>
                                        <DataProductPage
                                            idToken={idToken}
                                            dataProduct={value}
                                            fromDate={fromDate}
                                            toDate={toDate}
                                            getLatest={getLatest}
                                            dateFormat={dateFormat}
                                            resubmit={resubmit}
                                            dataPreviewRowCount={dataPreviewRowCount}
                                            formData={formData}
                                            setMessage={setMessage}
                                            setClassName={setClassName}
                                            setShowBanner={setShowBanner}
                                            dataProductDetails={dataProductDetails}
                                        />
                                    </Grid>
                                </Grid>
                            </Collapse>
                    </Grid>
                    )}
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <RequestStatusAlert message={statusMessage} severity={severity} />
            </Grid>
            <Banner message={message} className={className} showBanner={showBanner} />
        </Grid>
    )
}

export default DataProductResult